import { useMemo } from 'react';
import { SectionKey } from '../../../../../types';
import {
  EnhancedFieldConfig,
  FormSchemaConfig,
} from '../../types/form/schema.types';
import { FormState } from '../../types';
import {
  createCommentsTextarea,
  createGroupedApprovalSection,
  createRejectionTextarea,
  createStandardDisabledState,
  createYesNoRadio,
} from '../shared';
import { shouldShowGiftHospitalityApproval } from '../GiftHospitalityDonation/authoriserRules';

export const useGiftHospitalityDonationDublinGiftHospitalityDonationDublinApprovalSchema = (
  formState: FormState
): FormSchemaConfig => {
  return useMemo<FormSchemaConfig>(() => {
    const sectionKey = 'gift_hospitality_donation_dublin_approval' as SectionKey;
    if (!shouldShowGiftHospitalityApproval(formState.data)) {
      return { sections: [] };
    }

    const isDisabled = createStandardDisabledState(formState, sectionKey);

    const fields: EnhancedFieldConfig[] = [
        createYesNoRadio({
          name: 'gift_hospitality_donation_dublin_approval_approve',
          label: 'Do you wish to authorise this request?',
          disabled: isDisabled,
          validationMessage: 'Please select yes or no',
        }),
        createRejectionTextarea({
          name: 'gift_hospitality_donation_dublin_approval_rejection_details',
          label: 'Rejection Details',
          disabled: isDisabled,
          decisionField: 'gift_hospitality_donation_dublin_approval_approve',
          validationMessage: 'Please enter the rejection details',
        }),
        createCommentsTextarea({
          name: 'gift_hospitality_donation_dublin_approval_comments',
          label: 'Additional Comments',
          disabled: isDisabled,
          decisionField: 'gift_hospitality_donation_dublin_approval_approve',
        }),

    ];

    return {
      sections: [
        createGroupedApprovalSection({
          title: 'Approval',
          fields,
        }),
      ],
      order: {
        priority: 2,
      },
    };
  }, [formState]);
};
